/**
 * Legacy `withholdCrowSight` / `restoreCrowSight`: while the bird is airborne
 * after a skip, its POI — marker AND chip — waits for it to land. The SDK has
 * no per-POI hide, so the marker leaves the scene and comes back.
 */
import type { DatumEngine, Poi } from '@datum-sdk/engine';
import type { SightId } from '../../../shared/sightsData';
import { revealSuppressedSight, suppressSight } from '../../../state/appState';

export interface CrowBirdPoi {
  withhold(): void;
  /** A no-op unless withheld — teardown calls it too, as legacy does. */
  restore(): void;
}

export const createCrowBirdPoi = (
  engine: DatumEngine,
  sightId: SightId | undefined,
): CrowBirdPoi => {
  let withholding = false;
  let withheld: Poi | null = null;
  return {
    withhold: () => {
      if (sightId == null || withholding) return;
      withholding = true;
      const poi = engine.getPoiById(String(sightId));
      if (poi) {
        withheld = structuredClone(poi);
        engine.removePoi(poi.id);
      }
      suppressSight(sightId);
    },
    restore: () => {
      if (sightId == null || !withholding) return;
      withholding = false;
      if (withheld) engine.updatePoi(withheld);
      withheld = null;
      revealSuppressedSight(sightId);
    },
  };
};
